import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Notifications
import {addNotification} from "../notifications/notifications-actions";
import i18n from "../i18n";

// Constants
export const FETCH_CLIENTS_REQUEST = "FETCH_CLIENTS_REQUEST";
export const FETCH_CLIENTS_SUCCESS = "FETCH_CLIENTS_SUCCESS";
export const FETCH_CLIENTS_ERROR = "FETCH_CLIENTS_ERROR";
export const CREATE_CLIENT_REQUEST = "CREATE_CLIENT_REQUEST";
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const CREATE_CLIENT_ERROR = "CREATE_CLIENT_ERROR";
export const UPDATE_CLIENT_REQUEST = "UPDATE_CLIENT_REQUEST";
export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS";
export const UPDATE_CLIENT_ERROR = "UPDATE_CLIENT_ERROR";
export const UPDATE_CLIENT_STATUS_REQUEST = "UPDATE_CLIENT_STATUS_REQUEST";
export const UPDATE_CLIENT_STATUS_SUCCESS = "UPDATE_CLIENT_STATUS_SUCCESS";
export const UPDATE_CLIENT_STATUS_ERROR = "UPDATE_CLIENT_STATUS_ERROR";
export const DELETE_CLIENT_REQUEST = "DELETE_CLIENT_REQUEST";
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";
export const DELETE_CLIENT_ERROR = "DELETE_CLIENT_ERROR";

export const readClients = () => {
    return async (dispatch) => {
        try {
            dispatch(fetchClientsRequest());

            const res = await readClientsRequest();

            dispatch(utilsLib.response(res, fetchClientsSuccess, fetchClientsError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchClientsError));
        }
    };
};

export const readClientsRequest = async () => {
    const token = getTokenFromLocalStorage();
    return await axios.get('/api/clients', { headers: { 'Authorization': 'Bearer ' + token } });
};

const fetchClientsRequest = () => {
    return {
        type: FETCH_CLIENTS_REQUEST
    };
};

const fetchClientsSuccess = (payload) => {
    return {
        type: FETCH_CLIENTS_SUCCESS,
        payload
    };
};

const fetchClientsError = (errorMessage) => {
    return {
        type: FETCH_CLIENTS_ERROR,
        errorMessage
    };
};

export const readClientRequest = async (clientId) => {
    const token = getTokenFromLocalStorage();
    return await axios.get(`/api/clients/${clientId}`, { headers: { 'Authorization': 'Bearer ' + token } });
};

export const createClient = (client) => {
    return async (dispatch) => {
        try {
            dispatch(createClientRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/clients', client, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createClientSuccess, createClientError));

            // Create notification for update client success
            dispatch(addNotification({
                message: i18n.t("clients:toaster.success.createClient"),
                color: 'green',
                icon: 'tick'
            }));

        } catch (err) {
            dispatch(utilsLib.response(err, createClientError));
        }
    };
};

const createClientRequest = () => {
    return {
        type: CREATE_CLIENT_REQUEST
    };
};

const createClientSuccess = (payload) => {
    return {
        type: CREATE_CLIENT_SUCCESS,
        payload
    };
};

const createClientError = (errorMessage) => {
    return {
        type: CREATE_CLIENT_ERROR,
        errorMessage
    };
};

export const updateClient = (client) => {
    return async (dispatch) => {
        try {
            dispatch(updateClientRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.put(`/api/clients/${client._id}`, client, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateClientSuccess, updateClientError));

            // Create notification for update client success
            dispatch(addNotification({
                message: i18n.t("clients:toaster.success.updateClient"),
                color: 'green',
                icon: 'tick'
            }));

        } catch (err) {
            dispatch(utilsLib.response(err, updateClientError));
        }
    };
};

const updateClientRequest = () => {
    return {
        type: UPDATE_CLIENT_REQUEST
    };
};

const updateClientSuccess = (payload) => {
    return {
        type: UPDATE_CLIENT_SUCCESS,
        payload
    };
};

const updateClientError = (errorMessage) => {
    return {
        type: UPDATE_CLIENT_ERROR,
        errorMessage
    };
};

export const updateClientStatus = (client) => {
    return async (dispatch) => {
        try {
            dispatch(updateClientStatusRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.put(`/api/clients/${client._id}/status`, client, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateClientStatusSuccess, updateClientStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateClientStatusError));
        }
    };
};

const updateClientStatusRequest = () => {
    return {
        type: UPDATE_CLIENT_STATUS_REQUEST
    };
};

const updateClientStatusSuccess = (payload) => {
    return {
        type: UPDATE_CLIENT_STATUS_SUCCESS,
        payload
    };
};

const updateClientStatusError = (errorMessage) => {
    return {
        type: UPDATE_CLIENT_STATUS_ERROR,
        errorMessage
    };
};

export const deleteClient = (client) => {
    return async (dispatch) => {
        try {
            dispatch(deleteClientRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.delete(`/api/clients/${client._id}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteClientSuccess, deleteClientError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteClientError));
        }
    };
};

const deleteClientRequest = () => {
    return {
        type: DELETE_CLIENT_REQUEST
    };
};

const deleteClientSuccess = (payload) => {
    return {
        type: DELETE_CLIENT_SUCCESS,
        payload
    };
};

const deleteClientError = (errorMessage) => {
    return {
        type: DELETE_CLIENT_ERROR,
        errorMessage
    };
};